import { render } from "./Notes3.vue?vue&type=template&id=5b5cbedb&scoped=true"
import script from "./Notes3.vue?vue&type=script&lang=js"
export * from "./Notes3.vue?vue&type=script&lang=js"

import "./Notes3.vue?vue&type=style&index=0&id=5b5cbedb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5cbedb"]])

export default __exports__